import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';

export class RegisterDeepLinkAction extends CasinoLegacyDeepLinkActionBase {

  async execute(): Promise<void> {
    await this.services.messageBroker.channels.performAction.topics.register.execute({
      actionData: {
        ...this.descriptor.marketingParams
      }
    });
    await this._executeNextAction();
  }
}
